exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--6-1!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!sweetalert2/dist/sweetalert2.min.css"), "");
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--6-1!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!vue-select/dist/vue-select.css"), "");

// module
exports.push([module.id, "\n.col-form-label[data-v-01d28f0e] {\n  margin-top: 10px;\n}\n", ""]);

// exports
